import React, { useEffect, useState } from "react";

// i18n
import i18n from '@/i18n';
import { useTranslation } from "react-i18next";

// Custom components
import App from "@/App";
import Splash from "@/Splash";


const AppLoader = () => {
    const { t } = useTranslation();

    return !i18n.isInitialized ? (
        <Splash />
    ) : (
        <App />
    )
}

export default AppLoader;